import React from 'react';
import { SectionHeading } from './SectionHeading';
const blocks = [{
  title: 'ORIENTACIÓN ESPIRITUAL PARA SITUACIONES SENTIMENTALES',
  text: 'Consultas personalizadas para conversar sobre lo que estás viviendo en tu vida sentimental desde una perspectiva espiritual tradicional.'
}, {
  title: 'PRÁCTICAS TRADICIONALES RELACIONADAS CON EL AMOR Y LAS RELACIONES',
  text: 'Rituales y prácticas ancestrales vinculadas al amor y a los lazos afectivos, adaptadas a las circunstancias de cada persona.'
}, {
  title: 'RITUALES TRADICIONALES PARA SITUACIONES DE PAREJA',
  text: 'Acompañamiento espiritual y rituales tradicionales para quienes atraviesan situaciones de pareja y desean explorarlas desde lo espiritual.'
}];
export function LoveGuidance() {
  return <section aria-labelledby="amor-title" className="relative overflow-hidden border-t border-silver/10 bg-carbon py-20 sm:py-28" data-id="element-107" data-mp="33jahqtq0y2v5">
      <div aria-hidden="true" className="absolute right-0 top-10 h-72 w-72 rounded-full bg-violet-deep/40 blur-[120px]" data-id="element-108" data-mp="2ykfrx7tn3e1j" />
      <div className="relative mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-109" data-mp="cve4k2ka0g9d">
        <SectionHeading id="amor-title" eyebrow="Amor y vínculos" title="ORIENTACIÓN ESPIRITUAL PARA SITUACIONES SENTIMENTALES" align="left" data-id="element-110" data-mp="cxh0f38413m0" />

        <ol className="mt-14 space-y-px overflow-hidden rounded-2xl border border-silver/15 bg-violet-dark/30" data-id="element-111" data-mp="lu83w0ozrkqm">
          {blocks.map((block, index) => <li key={block.title} className="flex flex-col gap-4 border-b border-silver/10 p-7 last:border-b-0 sm:flex-row sm:items-start sm:gap-8 sm:p-9" data-id="element-112" data-mp="3qblsbx8dwxne" data-mpi={index}>
              <span aria-hidden="true" className="font-display text-2xl font-light text-accent-soft/70 sm:w-12" data-id="element-113" data-mp="2yi1icd5cmc7">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div data-id="element-114" data-mp="36kqkf09sr5ul">
                <h3 className="font-display text-lg font-light leading-snug tracking-[0.08em] text-frost sm:text-xl" data-id="element-115" data-mp="36k723ig8ifg1">
                  {block.title}
                </h3>
                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-silver sm:text-[0.95rem]" data-id="element-116" data-mp="8sq35vnrqho0">
                  {block.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}